import {
    WORK_ORDERS_REQUEST,
    WORK_ORDERS_SUCCESS,
    WORK_ORDERS_ERROR,

    WORKORDER_UPDATE_REQUEST,
    WORKORDER_UPDATE_SUCCESS,
    WORKORDER_UPDATE_ERROR
  
} from "../actions/workorders";
import HTTP from "@/utils/http";
//import axios from 'axios';
////import ajax from 'jquery';
import Vue from "vue";
import { AUTH_LOGOUT } from "../actions/auth";

const state = {
  workorders: [],
  workorders_get_status: "",
  workorders_new_status: "",
  workorders_once_loaded: false,

  workorder_status_status: "", // запрос статуса заказа (состояние запроса)
};

const getters = {
    getWorkOrders: state => state.workorders,
    isWorkOrdersLoading: state => state.workorders_get_status === 'loading',
    isWorkOrdersFailed: state => state.workorders_get_status === 'error',
    isWorkOrdersNewLoading: state => state.workorders_new_status === 'loading',

    getWorkOrderById: state => id => state.workorders.find( wo => wo.id == id ),
    //getWorkOrderById: state => { return state.workorders[0] },

    workOrdersOnceLoaded: state => state.workorders_once_loaded,
  
  };

 const actions = {
    [WORK_ORDERS_REQUEST]: ({ commit, dispatch }) => {
      return new Promise((resolve, reject) => {
      commit(WORK_ORDERS_REQUEST);
      HTTP({ url: "work_orders" })
        .then(resp => {
          commit(WORK_ORDERS_SUCCESS, resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit(WORK_ORDERS_ERROR);
          if (err.status === 401) {
            dispatch(AUTH_LOGOUT);
          }
          reject(err);
        });
      });
    },

    [WORKORDER_UPDATE_REQUEST]: ({ commit, dispatch }, req) => {
      return new Promise((resolve, reject) => {
        commit(WORKORDER_UPDATE_REQUEST);
        HTTP({ url: "work_orders", data: req.data, method: req.method })
          .then(resp => {
            commit(WORKORDER_UPDATE_SUCCESS, req);
            resolve(resp);
          })
          .catch(err => {
            commit(WORKORDER_UPDATE_ERROR, err);
            if (err.status === 401) {
              dispatch(AUTH_LOGOUT);
            }
            reject(err);
          });
      });
    },    
}

const mutations = {
  [WORK_ORDERS_REQUEST]: state => {
    state.workorders_get_status = "loading";
  },
  [WORK_ORDERS_SUCCESS]: (state, data) => {
    state.workorders_get_status = "success";
    Vue.set(state, "workorders", data);
    state.workorders_once_loaded = true;
  },
  [WORK_ORDERS_ERROR]: state => {
    state.workorders_get_status = "error";
    state.workorders_once_loaded = true;
  },

  [WORKORDER_UPDATE_REQUEST]: state => {
    state.workorders_get_status = "loading";
  },

  [WORKORDER_UPDATE_SUCCESS]: (state, data) => {
    state.workorders_get_status = "success";
    console.log( data );
    /*let body = JSON.parse(data.body);
    console.log(body);
    for (let i = 0; i < state.cards.length; i++) {
      const n = state.cards[i];
      if (n.id === data.card_id) {
        console.log('updated card ' + data.card_id);
        let new_card = Object.assign({}, n);
        new_card.holder_name = body.holder_name;
        new_card.pin = body.pin;
        new_card.volume_limit.target_values = body.volume_limit.target_values;
        new_card.money_limit.target_values = body.money_limit.target_values;

        state.cards.splice(i, 1, new_card)
      }
    }*/
  },
  [WORKORDER_UPDATE_ERROR]: state => {
    state.workorders_get_status = "error";
  },
  




  [AUTH_LOGOUT]: state => {
    state.workorders = [];
    state.workorders_get_status = "";
    state.workorders_new_status = "";
    state.workorders_once_loaded = false;
  }
};


export default {
    state,
    getters,
    actions,
    mutations
  };
  
